<template>
  <div class="animated fadeIn">
    <Forms ref="frmGroup"
      :title="'CADASTRO DE PARÂMETROS DE CRIAÇÃO DE CARDS PARA NOVAS CONTAS CAPITAIS'"
      :showClearButton="true"
      :showSaveButton="true"
      v-on:Clear="onClear"
      v-on:Save="onSave"
    >
      <div class="form-group row">
        <div class="input-group" style="background: none">
          <div class="col-md-4">
            <SelectEvento
              ref="eventoComponent"
              @onSelect="saveEvento"
              :selectedOption="data.eventoId"
            />
          </div>
          <div class="col-md-4 pt-2 pt-sm-0">
            <SelectBoard
              ref="boardComponent"
              @onSelect="loadColumns"
              :onlyActive="true"
              :selectedOption="data.boardId"
            />
          </div>
          <div class="col-md-4 pt-2 pt-sm-0">
            <SelectBoardColumn
              v-if="data.boardId"
              ref="boardColumnComponent"
              @onSelect="saveBoardAndColumn"
              :boardId="data.boardId"
              :selectedOption="data.boardColumnId"
              :key="data.boardId"
            />
          </div>
          <div class="col-md-4 pt-2 pt-sm-0">
            <SelectOrigem
              v-if="data.boardColumnId"
              ref="originComponent"
              @onSelect="saveOrigin"
              :selectedOption="data.origemLeadId"
            />
          </div>
        </div>
      </div>
    </Forms>
  </div>
</template>

<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import { toast, loading } from '@/shared/utils/UIHelper'

import ParametroAberturaCardsVisitaRepository from '@/shared/http/repositories/configurations/parametroAberturaCardsVisita.js'

import SelectBoard from '@/components/forms/selects/SelectBoard.vue'
import SelectBoardColumn from '@/components/forms/selects/SelectBoardColumn.vue'
import SelectOrigem from '@/components/forms/selects/SelectOrigem.vue'
import SelectEvento from '@/components/forms/selects/SelectEvento.vue'

const data = {
  id: null,
  boardId: null,
  boardColumnId: null,
  origemLeadId: null,
  eventoId: null
}

export default {
  name: 'OpenCardVisitasParams',
  mixins: [ ActionsForm ],
  data () {
    return {
      data: data
    }
  },
  components: {
    SelectBoard,
    SelectBoardColumn,
    SelectOrigem,
    SelectEvento
  },
  methods: {
    async onLoad () {
      try {
        loading.push()
        const resp = await ParametroAberturaCardsVisitaRepository.Get()

        if (!resp || !resp.data) {
          return
        }

        this.setResponseInData(resp.data)
      } catch (error) {
        this.onExceptionWithErrorMessage(error)
      } finally {
        loading.close()
      }
    },
    onClear () {
      this.data.boardId = null
      this.data.boardColumnId = null
      this.data.origemLeadId = null
      this.data.eventoId = null
    },
    async onCreate () {
      try {
        loading.push()
        const response = await ParametroAberturaCardsVisitaRepository.Create(this.data)

        if (response && response.status === 201) toast.success(this.$lang.Common.Alerts.Success)
      } catch (error) {
        this.onExceptionWithErrorMessage(error)
      } finally {
        loading.close()
      }
    },
    async onUpdate () {
      try {
        loading.push()
        const response = await ParametroAberturaCardsVisitaRepository.Update(this.data)

        if (response && response.status === 201) toast.success(this.$lang.Common.Alerts.Success)
      } catch (error) {
        this.onExceptionWithErrorMessage(error)
      } finally {
        loading.close()
      }
    },
    saveEvento (eventoId) {
      this.data.eventoId = eventoId
    },
    loadColumns (boardId) {
      this.data.boardId = boardId
      this.data.boardColumnId = null
      this.data.origemLeadId = null
    },
    saveBoardAndColumn (boardAndColumn) {
      this.data.boardId = boardAndColumn[0]
      this.data.boardColumnId = boardAndColumn[1]
    },
    saveOrigin (origemLeadId) {
      this.data.origemLeadId = origemLeadId
    },
    setResponseInData (respData) {
      this.data.id = parseInt(respData.id)
      this.data.boardId = respData.boardId
      this.data.boardColumnId = respData.boardColumnId
      this.data.origemLeadId = respData.origemLeadId
      this.data.eventoId = respData.eventoId
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/configurations/parametros/visitas/aberturaCard/OpenCardsVisitasParams.vue